import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { checkRouteAccess } from "./ProtectedMenu";
import { useAuthContext } from "../common/providers/AuthProvider";

/** Always reachable for a logged-in admin (menu shows Dashboard without Screens entry). */
const ADMIN_SHELL_PATHS = new Set(["/", "/admin/dashboard", "/unauthorized"]);

const AdminRoute = ({ children, accessList, accessToken }) => {
  const location = useLocation();
  const { isLoading, isLogin } = useAuthContext();
  const path = location.pathname;

  // Refresh / F5: wait until session + accessList restore — never flash 403 while logged in.
  if (accessToken && isLoading) {
    return null;
  }

  if (!accessToken) {
    return (
      <Navigate to="/unauthorized" state={{ from: location }} replace />
    );
  }

  if (ADMIN_SHELL_PATHS.has(path)) {
    return children;
  }

  const hasAccess =
    checkRouteAccess(path, accessList) ||
    (path === "/admin/roadshow" &&
      checkRouteAccess("/admin/cnf/number", accessList));

  // Cached admin role with empty list still hydrating — don't bounce to 403.
  if (!hasAccess && isLogin?.role && (!accessList || accessList.length === 0)) {
    return null;
  }

  if (hasAccess) {
    return children;
  }

  return (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default AdminRoute;
